import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { getAcknowledgementsConfig } from '@/api/settings';

export const useAcknowledgementsConfigStore = defineStore('acknowledgementsConfig', () => {
  const config = ref(null);

  const acknowledgementCycleSla = computed(() => (
    config.value?.acknowledgement_cycle_sla || 0
  ));

  const acknowledgementPendingSla = computed(() => (
    config.value?.acknowledgement_pending_sla || 0
  ));

  const loadConfig = async () => {
    try {
      config.value = await getAcknowledgementsConfig();
    } catch (e) {
      config.value = null;
    }
  };

  return {
    config,
    acknowledgementCycleSla,
    acknowledgementPendingSla,
    loadConfig,
  };
});
